import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { getTheme } from '@cw-ui/asio-neon-themes';

const neonTheme = getTheme('light');

const NeonThemeProvider = ({ children }) => <ThemeProvider theme={neonTheme}>{children}</ThemeProvider>;

export default NeonThemeProvider;
